angular.module('capability-ng-transfer').directive('syncHiComponentValue', function syncHiComponentValue($parse) {
  return {
    restrict: 'A',
    scope: {
      syncHiComponentValue: '=syncHiComponentValue'
    },
    link: function($scope: any, elem: any, attrs: any) {
      const onValueChanged = (event: any) => {
        $scope.syncHiComponentValue = event.detail.value;
      };
      elem[0].addEventListener('value-changed', onValueChanged);

      $scope.$on('$destroy', () => {
        elem[0].removeEventListener('value-changed', onValueChanged);
      });
      if (!_.isNull($scope.syncHiComponentValue) && !_.isUndefined($scope.syncHiComponentValue)) {
        if (_.isString($scope.syncHiComponentValue) && $scope.syncHiComponentValue.trim() !== '') {
          elem[0].value = $scope.syncHiComponentValue;
          return;
        }
        if (!_.isString($scope.syncHiComponentValue)) {
          elem[0].value = $scope.syncHiComponentValue;
        }
      }
    }
  };
});



// WEBPACK FOOTER //
// ./app/lib/transfer/directives/sync_hi_component_value.ts